import type { ReactNode } from 'react';

type Props = {
  color: 'black' | 'white';
  children?: ReactNode;
};

const COLOR_CLASS: Record<Props['color'], string> = {
  black: 'text-apps-coreGray02 opacity-100',
  white: 'opacity-50',
};

export default function NoListBodyText({ color, children }: Props) {
  return (
    <div
      className={`mt-3 w-full break-words text-center text-base font-medium leading-[150%] tracking-[-0.32px] lg:mt-2 ${COLOR_CLASS[color]}`}
    >
      {children}
    </div>
  );
}
